import { useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

function resetScrollPosition() {
  const root = document.documentElement;
  const previousValue = root.style.getPropertyValue('scroll-behavior');
  const previousPriority = root.style.getPropertyPriority('scroll-behavior');

  // The site deliberately uses smooth scrolling for in-page navigation.
  // Route changes must be instant, so temporarily override it while setting
  // the new document position and restore it before the browser paints.
  root.style.setProperty('scroll-behavior', 'auto', 'important');

  window.scrollTo(0, 0);

  // Keep a direct assignment as a defensive fallback for browsers where the
  // root scrolling element does not fully honour window.scrollTo immediately.
  if (document.scrollingElement) {
    document.scrollingElement.scrollTop = 0;
    document.scrollingElement.scrollLeft = 0;
  }

  if (previousValue) {
    root.style.setProperty('scroll-behavior', previousValue, previousPriority);
  } else {
    root.style.removeProperty('scroll-behavior');
  }
}

export function ScrollToTop({ children }) {
  const { pathname } = useLocation();
  const previousPathname = useRef(pathname);

  useLayoutEffect(() => {
    if (previousPathname.current === pathname) return;

    previousPathname.current = pathname;
    resetScrollPosition();
  }, [pathname]);

  return children;
}
